module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"prop-header\">\r\n        <div class=\"prop-header\"><span class=\"prop-label\">Custom Parameters</span></div>\r\n    </div>\r\n    <div class=\"row format-table-properties\" style=\"padding-left: 1px; height: 145px\">\r\n        <table id=\"propMainTable\"></table>   \r\n    </div>\r\n    <div id=\"propMainGridButtons\" style=\"margin-top:10px;\">\r\n        <button type=\"button\" id=\"\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\">\r\n            <i class=\"fa pf-add\"></i>\r\n        </button>\r\n        <button type=\"button\" id=\"\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\">\r\n            <i class=\"fa pf-delete icon-gradient\"></i>\r\n        </button>\r\n    </div> \r\n</div>\r\n")
  }
  return __output;

}